import { createContext } from "react";

const EscolaridadesContext = createContext();

export default EscolaridadesContext;
